module.exports = __webpack_public_path__ + "static/media/Ciro-Matthieu.ff959d36.png";